import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SKIP_ERROR_HANDLER } from '../models/load.models';
import { QcResponse } from '../models/qcResponse.model';
import { EnvironmentFacadeService } from './environment.facade.service';

@Injectable({
  providedIn: 'root',
})
export class EliquaService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
  ) {}

  getSubscriptionValidity(): Observable<QcResponse> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/entitlements';
    return this.http.get<QcResponse>(url, { withCredentials: true });
  }

  getCoreVersion(): Observable<any> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/system/core-version';
    return this.http.get<any>(url, {
      context: new HttpContext().set(SKIP_ERROR_HANDLER, true),
    });
  }

  getLanguage(): Observable<string> {
    const lang = localStorage.getItem('lang') || 'en';
    return of(lang);
  }

  logout(): Observable<any> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/auth/logout';
    return this.http.post(url, '', { withCredentials: true });
  }
}
